import { render, staticRenderFns } from "./NuestrosSocios.vue?vue&type=template&id=2064dfff&scoped=true"
import script from "./NuestrosSocios.vue?vue&type=script&lang=js"
export * from "./NuestrosSocios.vue?vue&type=script&lang=js"
import style0 from "./NuestrosSocios.vue?vue&type=style&index=0&id=2064dfff&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2064dfff",
  null
  
)

export default component.exports